import { createContext } from 'react'
import type { User, LoginRequest, LoginResult } from '../types/auth'

export interface AuthState {
  user: User | null
  permissions: string[]
  isAuthenticated: boolean
  isAdmin: boolean
  isLoading: boolean
}

export interface AuthContextType extends AuthState {
  /** Se l'utente ha il 2FA abilitato, risolve con { requiresTwoFactor: true, mfaToken, ... }
   *  senza autenticare - chiamare completeTwoFactorLogin per finire il login. */
  login: (data: LoginRequest) => Promise<LoginResult>
  completeTwoFactorLogin: (mfaToken: string, code: string) => Promise<void>
  logout: () => Promise<void>
  hasPermission: (permission: string) => boolean
  hasAnyPermission: (...permissions: string[]) => boolean
  refreshUser: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | null>(null)
